<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QGXyK/tc-custom/9780061860676.jpg?1731793812961" alt="This image is the cover for the book Of Men and Their Mothers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Of Men and Their Mothers
      </h1>
      <p class="bookDescription body article font2">
        <p>All men have mothers . . .</p><p>It's a truth that the newly unhyphenated Maisie Grey has learned the hard way. After getting rid of her mama's-boy husband, she happily settles down with her teenage son, Tommy. But she's still stuck with the hovering presence of her impossible mother-in-law,  Tommy's grandmother, who refuses to exit the family stage gracefully. </p><p>Trying to keep it together with her own business and a new relationship with a man who still lives in—<i>where else but?</i>—his mother's house, Maisie struggles to learn from the MIL-from-hell. She vows that when Tommy brings someone home, she'll be loving, empathetic, and supportive. But then along comes completely unsuitable September Silva—with her too-short skirts, black nail polish, and stay-out-all-night attitude—who is forcing Maisie to take a flinty, clear-eyed new look at what it means to be a mother.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mameve Medwed
      </h2>
      
      <p class="authorDescription body article"><P>Mameve Medwed is also the author of <I>Mail, Host Family, The End of an Error,</I> and <I>How Elizabeth Barrett Browning Saved My Life</I> (which received a 2007 Massachusetts Book Honor Award). Her stories, essays, and reviews have appeared in many publications including the <I>Missouri Review, Redbook,</I> the <I>Boston Globe, Yankee,</I> the<I> Washington Post,</I> and <I>Newsday</I>. Born in Maine, she and her husband have two sons and live in Cambridge, Massachusetts.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?da612426